import React from 'react';
import { useSelector } from 'react-redux';

import { Counter } from '@hpstellar/core';
import { X } from '@hpstellar/vis-icons';
import Button from '@hpstellar/core/visId/Button';
import Typography from '@hpstellar/core/visId/Typography';

import VisIDDropdown from './dropdown';
import { getClearAllFiltersGtmAttributes } from '../../../metrics/metrics-helpers';

import './sort-bar.less';

export default function sortBar({
    filterCount,
    clear,
    sortValues,
    sortGtmActions,
    onSort,
    resultsMessage,
    disableSort,
    sortMobileProps,
    className,
    totalProducts,
    orderBy

}) {
    const dropdownCommonProps = {
        key: orderBy,
        className: 'sortDropdown',
        options: sortValues,
        onChange: onSort,
        defaultValue: orderBy,
        gtmActions: sortGtmActions
    }

    const isMobile = useSelector(state => state && state.ui && state.ui.customBreakpoints && ['xsmall', 'small', 'medium'].includes(state.ui.customBreakpoints.visId));
    const isUsingFilters = filterCount > 0;
    const filters = !isMobile && (
        <div className="filterCount">
            {isUsingFilters && (
                <>
                    <Typography variant='caption'>
                        {`${filterCount} Filter${filterCount > 1 ? 's' : ''} Applied`}
                    </Typography>
                    <Button
                        className='clear'
                        variation='tertiary'
                        theme='light'
                        onClick={clear}
                        color='white'
                        {...getClearAllFiltersGtmAttributes()}
                    >
                        Clear All
                        <X className='filterClearIcon' size="s" />
                    </Button>
                </>
            )}
        </div>
    );
    
    const filtersAndProductCount = (
        <>
            {filters}
            <div className="productCount">
                {
                    resultsMessage ? resultsMessage : (
                        <Counter className="counter" count={resultsMessage ? null : totalProducts} size="large" subsetDelimiter="of" isCaps={false}>
                            Result{totalProducts > 1 ? 's' : ''}
                        </Counter>
                    )
                }
            </div>
        </>
    )
    return (
        <div className={`visIdSortBar${className ? ' '+className : ''}${isUsingFilters ? ' withFilter' : ''}`}>
            <div className='visIdFilterAndProductCount'>
                {
                    filtersAndProductCount
                }
            </div>
            {
                !disableSort && sortValues && (
                    <VisIDDropdown
                        label='Sort by'
                        mobileProps={sortMobileProps}
                        {...dropdownCommonProps}
                    />
                )
            }
        </div>
    );
}
